import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Logout_Modal.css";

function Logout_Modal({ show, handleClose, handleLogout }) {
  const navigate = useNavigate();
  // const onConfirmLogout = () => {
  //   if (handleLogout) {
  //     handleLogout();
  //   }
  //   navigate("/login");
  //   handleClose();
  // };

  const onConfirmLogout = () => {
    handleLogout(); // 🔥 IMPORTANT
    handleClose();
    navigate("/login");
  };

  return (
    <Modal show={show} onHide={handleClose} centered className="logout-modal">
      <Modal.Body className="text-center">
        <h5 className="mb-4">Are you sure you want to logout?</h5>
        <div className="d-flex justify-content-center gap-3 mb-0">
          <Button className="modal-btn" onClick={onConfirmLogout}>
            Yes
          </Button>

          <Button className="modal-btn active " onClick={handleClose}>
            No
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
export default Logout_Modal;
